import { render, staticRenderFns } from "./NewAttendance.vue?vue&type=template&id=ae24fd5a&scoped=true"
import script from "./NewAttendance.vue?vue&type=script&lang=js"
export * from "./NewAttendance.vue?vue&type=script&lang=js"
import style0 from "./NewAttendance.vue?vue&type=style&index=0&id=ae24fd5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae24fd5a",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
